import React from 'react';
import { Form, FormGroup, Label, Input, Button, Row, Col, Modal, ButtonToolbar } from 'reactstrap';
import Select from 'react-select';
import API from '../../../Common/api';

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import uploadIcon from '../../../../images/uploadNewIcon.svg';
import "./styles.css";

const urlParams = new URLSearchParams(window.location.search);
const paramValue = urlParams.get('id');


class HorizontalForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            employeeCode: '',
            failedModal: false,
            modalNew: false,
            fullName: '',
            email: '',
            mobile: '',
            city: '',
            role: null,
            tax_type: "",
            dataHistory: [],
            tax_community: "",
            inventoryOwner: null,
            itemCategoryList: [],
            brandList: [],
            divisionList: [],
            dropDownData: [],
            warehouses: [],
            warehouses_val: [],
            availableRoles: [],
            taxType: [],
            availableOwners: [],
            subCategoryList: [],
            taxCommunity: [],
            username_val: '',
            password: '',
            errors: {},
            itemDetails: [],
            productAttributes: [],
            productPricing: [],
            uomDetails: [],
            isAccordionOpen: true,
            sectionStatus: {
                itemDetails: false,
                productAttributes: false,
                pricingDetails: false,
                uomDetails: false
            }
        };
    }

    Failedtoggle = () => {
        this.setState((prevState) => ({ failedModal: !prevState.failedModal }));
    }

    toggleNew = () => {
        this.setState((prevState) => ({ modalNew: !prevState.modalNew }));
    }

    toggleBack = () => {
        window.location.href = "/upload/item_master?tab=item_list";  
    }

    editItem = ()=>{
        window.location.href = '/upload/update_items_details';
    }

    /*handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value, errors: { ...this.state.errors, [name]: '' } });
    };*/
    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState(
            { [name]: value, errors: { ...this.state.errors, [name]: '' } },
            () => {
                this.setState({
                    sectionStatus: {
                        itemDetails: this.isSectionComplete('itemDetails'),
                        productAttributes: this.isSectionComplete('productAttributes'),
                        pricingDetails: this.isSectionComplete('pricingDetails'),
                        uomDetails: this.isSectionComplete('uomDetails'),
                    }
                });
            }
        );
         if(event.target.name == "item_category"){

            API.get('/tax/v1/item-list/product/dropdown/sub-category?category='+event.target.value)
            .then((response) => response.data)
            .then((data) => {
                /*console.log("sub_category",data.data);*/
                this.setState({
                    subCategoryList: data.data.sub_category
                })
            })
            .catch((error) => console.error(error));
            

        }

        if(event.target.name == "brand"){

            API.get('/tax/v1/item-list/product/dropdown/sub-brand?brand='+event.target.value)
            .then((response) => response.data)
            .then((data) => {
                console.log('sub_brand',data)
                // this.setState({
                //     subBrandList: data.data.sub_brand
                // })
            })
            .catch((error) => console.error(error));

        }
    };
    isSectionComplete = (section) => {
        switch (section) {
            case 'itemDetails':
                return (
                    this.state.item_code &&
                    this.state.item_name &&
                    this.state.item_type &&
                    this.state.item_category &&
                    this.state.sub_category &&
                    this.state.brand &&
                    this.state.sub_brand &&
                    this.state.hsn_code &&
                    this.state.hht_item_desc
                );
            case 'productAttributes':
                return (
                    this.state.ean &&
                    this.state.upc &&
                    this.state.ean_each_length &&
                    this.state.ean_each_breadth &&
                    this.state.ean_each_height 
                );
            case 'pricingDetails':
                return (
                    this.state.mrp &&
                    this.state.std_cost &&
                    this.state.per_qty
                );
            case 'uomDetails':
                return (
                    this.state.purchase_uom &&
                    this.state.std_purchase_price &&
                    this.state.sales_uom
                );
            default:
                return false;
        }
    };

    componentDidMount() {
        this.getDropDownData();
        this.fetchBinData();
         const accordion = document.getElementById("create_item_accordian");
         const accordion_buttons = document.getElementsByClassName("accordion__button");
         const accordion_items = document.getElementsByClassName("accordion__item");
         const accordion__panel = document.getElementsByClassName("accordion__panel");

        if (accordion) {
            accordion.style.setProperty("width", "92%", "important");
            accordion.style.setProperty("border", "0px", "important");
        }


        if (accordion_buttons.length > 0) {  // Check if elements exist
            for (let button of accordion_buttons) {
                button.style.setProperty("background-color", "#fff", "important");
                button.style.setProperty("font-weight", "bold", "important");
            }

        }

        if (accordion_items.length > 0) {  // Check if elements exist
            for (let button of accordion_items) {
                button.style.setProperty("margin-bottom", "10px", "important");
                button.style.setProperty("border", "0px", "important");
                
            }

        }

         if (accordion__panel.length > 0) {  // Check if elements exist
            for (let button of accordion__panel) {
                button.style.setProperty("background-color", "#fff", "important");
                
                
            }

        }
    }

    fetchBinData(page = 1){
      this.setState({
        showFetchBinData: true,
        showFetchBaseData: false,
        showFetchProductData: false,
        showFetchTesterData: false,
        loading_overlay:true
      })

      const url = `/tax/v1/item-list/product/${paramValue}`;
      API.get(url)
      /*callapiobj.get('/tax/v1/item-list/product/', { param: payload })*/

      .then(response => response.data)

      .then(data => {

         console.log("Area Data",data);

         this.setState({
            itemDetails: data.data.item_details,
            productAttributes: data.data.product_attributes,
            productPricing: data.data.product_pricing,
            uomDetails: data.data.uom_details,
            dataHistory: data.data.data_history,
            item_name: data.data.item_details.lb_sku_product_name,
            item_type: data.data.item_details.item_type,
            item_category: data.data.item_details.category,
            sub_category: data.data.item_details.sub_category,
            division: data.data.item_details.sub_division,
            brand: data.data.item_details.brand,
            sub_brand: data.data.item_details.sub_brand,
            hsn_code: data.data.item_details.hsn_code,
            hht_item_desc: data.data.item_details.item_description,
            ean: data.data.product_attributes.ean,
            upc: data.data.product_attributes.upc,
            ean_each_length: data.data.product_attributes.ean_each.length,
            ean_each_breadth: data.data.product_attributes.ean_each.breadth,
            ean_each_height: data.data.product_attributes.ean_each.height,
            ean_cases_length: data.data.product_attributes.ean_cases.inner_length,
            ean_cases_breadth: data.data.product_attributes.ean_cases.inner_breadth,
            ean_cases_height: data.data.product_attributes.ean_cases.inner_height,
            shelf_life: data.data.product_attributes.shelf_life,
            mrsl: data.data.product_attributes.mrsl,
            mrp: data.data.product_pricing.mrp,
            per_qty: data.data.product_pricing.per_qty,
            std_cost: data.data.product_pricing.std_cost,
            purchase_uom: data.data.uom_details.purchase_uom,
            sales_uom: data.data.uom_details.sales_uom,
            std_purchase_price: data.data.uom_details.std_purchase_price,
        })


         this.getSubCategory(data.data.item_details.category)
         this.getSubBrand(data.data.item_details.brand)

      })

      .then(async() => {

         /*this.setState({ tableRows:this.assemblePosts(), loading_overlay:false })

         console.log(this.state.tableRows);*/

      });
    }

    getSubBrand = (brand)=>{

        API.get('/tax/v1/item-list/product/dropdown/sub-brand?brand='+brand)
        .then((response) => response.data)
        .then((data) => {
            console.log('sub_brand',data)
            // this.setState({
            //     subBrandList: data.data.sub_brand
            // })
        })
        .catch((error) => console.error(error));
    }

    getSubCategory = (category)=>{
        API.get('/tax/v1/item-list/product/dropdown/sub-category?category='+category)
        .then((response) => response.data)
        .then((data) => {
            /*console.log("sub_category",data.data);*/
            this.setState({
                subCategoryList: data.data.sub_category
            })
        })
        .catch((error) => console.error(error));
    }

    handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            console.log("File selected:", file.name);
            // You can update state or handle file upload here
        }
    };

    getDropDownData = () => {
        API.get('/tax/v1/item-list/product/dropdown/')
            .then((response) => response.data)
            .then((data) => {
                console.log("dropdown",data.data.item_category);
                this.setState({
                    dropDownData: data.data,
                    itemCategoryList: data.data.item_category,
                    brandList: data.data.brand,
                    divisionList: data.data.division
                })
            })
            .catch((error) => console.error(error));
    };

    updateItem = () => {
        console.log(this.state.item_category)
        this.setState({
            loading: true
        })
        const payload = {
            item_details : {
                "lb_sku_product_name": this.state.item_name,
                "product_type": 0,
                "category": this.state.item_category,
                "sub_category": this.state.sub_category,
                "sub_division": this.state.division,
                "brand": this.state.brand,
                "sub_brand": this.state.sub_brand,
                "base_pack_code": this.state.itemDetails.sku7_code,
                "sku": this.state.itemDetails.sku7_code,
                "status": "1",
                "hsn_code": this.state.hsn_code,
                "item_description": this.state.hht_item_desc
            },
            product_attributes: {
               "ean": this.state.ean,
               "sku":this.state.itemDetails.sku7_code,
               "ean_each": {
                   "length": this.state.ean_each_length,
                   "breadth": this.state.ean_each_breadth,
                   "height": this.state.ean_each_height
               },
               "ean_cases": {
                   "length": this.state.ean_cases_length,
                   "breadth": this.state.ean_cases_breadth,
                   "height": this.state.ean_cases_height
               },
               "upc": 12,
               
            },
            product_pricing: {
               "mrp": this.state.mrp,
               "std_cost": this.state.std_cost,
               "per_qty": this.state.per_qty
            },
           uom_details: {
               "purchase_uom": this.state.purchase_uom,
               "std_purchase_price": this.state.std_purchase_price,
               "sales_uom": this.state.sales_uom
           }

        };

        API.put(`/tax/v1/item-list/product/${paramValue}`, { param: payload })
            .then((response) => response.data)
            .then((data) => {
                console.log(data)

                if(data.status == true){
                   this.setState({
                    success_message: data.message,
                    modalNew: true,
                    loading: false
                }); 
                }else{
                    this.setState({
                        failed_message: data.message,
                        failedModal: true,
                        loading: false
                    });
                }

                /*this.setState({
                    success_message: data[0].message,
                    username_val: data[0].username,
                    password: data[0].password,
                    modalNew: true,
                });*/

            })
           .catch((error) => {
              console.log(error.response.data.message)
                if (error.response.status == "400") {
                    this.setState({
                        failed_message: error.response.data.message,
                        failedModal: true,
                    });
                } else {
                    console.log(error);
                }
            });
    }
      handleAccordionToggle = (isOpen) => {
        this.setState({ isAccordionOpen: isOpen });
    };

    render() {
        const { errors, modalNew, failedModal, dropDownData, itemDetails, productAttributes, uomDetails, productPricing, dataHistory } = this.state;
        console.log()
        const isActive = itemDetails.status == 3;


        return (
            <div id="createItem_container" style={{ width: '100%', margin: '1%' }}>
                {/*<div className="statusStyle" >
                    <span  className="dotStyle"></span>
                    <span style={{ color: isActive ? 'green' : 'red', fontWeight: 'bold' }}>
                        {isActive ? 'Active' : 'Inactive'}
                    </span>
                </div>*/}
                <div className="status-container">
                    <div className="status-left">
                        <span style={{marginRight: 8, color: '#777777', fontWeight: 'bold'}}> Item Status </span>
                        <span className={`status-dot ${itemDetails.status == "Active" ? 'status-dot-active' : itemDetails.status == "Missing Information" ? 'status-dot-inactive' : 'status-dot-pending'}`}></span>
                        <span>
                            {itemDetails.status}
                        </span>
                    </div>
                    <button onClick={this.editItem} className="edit-button">
                       <i className="fa fa-edit edit-icon" aria-hidden="true"></i> Edit Rule
                    </button>
                </div>
                
                    <Accordion 
                        id="create_item_accordian" 
                       style={{ width: '100%', maxWidth: '100vw' }} 
                        allowMultipleExpanded 
                        allowZeroExpanded
                        preExpanded={['itemDetails', 'pricingDetails', 'uomDetails']}
                        onChange={(expandedItems) => this.handleAccordionToggle(expandedItems.length > 0)}
                    >
                        {/* Section 1 */}
                        <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                    <span className="accordian_title">Item Details</span>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="username">Item Code <span style={{ color: "red" }}>*</span></Label>
                                            <Input
                                                disabled
                                                type="text"
                                                name="item_code"
                                                value={itemDetails.sku7_code}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Item Name <span style={{ color: "red" }}>*</span></Label>
                                            <Input
                                                type="text"
                                                name="item_name"
                                                defaultValue={this.state.item_name}
                                                onChange={this.handleChange}
                                                
                                                
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Item Type <span style={{ color: "red" }}>*</span></Label>
                                            <Input
                                                
                                                type="text"
                                                name = "item_type"
                                                value={this.state.item_type}
                                                onChange={this.handleChange}
                                                
                                                
                                            />
                                        </FormGroup>
                                    </Col>

                                </Row>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="username">Item Category <span style={{ color: "red" }}>*</span></Label>
                                            <select
                                                name="item_category"
                                                className="form-control"
                                                value={this.state.item_category}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                                
                                            >
                                                {this.state.itemCategoryList.map((item) => (
                                                  <option  value={item}>
                                                    {item}
                                                  </option>
                                                ))}
                                            </select>
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Sub Category <span style={{ color: "red" }}>*</span></Label>
                                            <select
                                                name="sub_category"
                                                className="form-control"
                                                value={this.state.sub_category}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                                
                                            >
                                                {this.state.subCategoryList.map((item) => (
                                                    <option key={item} value={item}>{item}</option>
                                                ))}
                                            </select>
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Division</Label>
                                             <select
                                                name="division"
                                                className="form-control"
                                                value={this.state.division}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                                
                                            >
                                                {this.state.divisionList.map((item) => (
                                                    <option key={item} value={item}>{item}</option>
                                                ))}
                                            </select>
                                        </FormGroup>
                                    </Col>

                                </Row>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="username">Brand <span style={{ color: "red" }}>*</span></Label>
                                            <select
                                                name="brand"
                                                className="form-control"
                                                value={this.state.brand}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                                
                                            >
                                                
                                                {this.state.brandList.map((item) => (
                                                    <option key={item} value={item}>{item}</option>
                                                ))}
                                            </select>
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Sub Brand <span style={{ color: "red" }}>*</span></Label>
                                            <select
                                                name="sub_brand"
                                                className="form-control"
                                                value={this.state.sub_brand}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                                
                                            >
                                                <option value="">{itemDetails.sub_brand}</option>
                                            </select>
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Basepack</Label>
                                             <Input
                                                type="text"
                                                name="basepack"
                                                value={itemDetails.base_pack_code}
                                                disabled
                                            />

                                            {/*<select
                                                name="tax_type"
                                                className="form-control"
                                                value={this.state.tax_type}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                            >
                                                <option value="">Select Type</option>
                                                {this.state.taxType.map((item) => (
                                                    <option key={item.value} value={item.value}>{item.label}</option>
                                                ))}
                                            </select>*/}
                                        </FormGroup>
                                    </Col>

                                </Row>

                                 <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="username">HSN Code<span style={{ color: "red" }}>*</span></Label>
                                            <Input
                                                type="text"
                                                name="hsn_code"
                                                defaultValue={this.state.hsn_code}
                                                onChange={this.handleChange}

                                                
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={8}>
                                        <FormGroup>
                                            <Label for="city">HHT Item Description<span style={{ color: "red" }}>*</span></Label>
                                             <Input
                                                type="text"
                                                name="hht_item_desc"
                                                defaultValue={this.state.hht_item_desc}
                                                onChange={this.handleChange}
                                                
                                            
                                            />
                                        </FormGroup>
                                    </Col>
                                    

                                </Row>

                                <Row form>
                                    <Col md={4} style={{border: '1px solid', borderColor: '#AAAAAA33', padding: '10px'}} className="d-flex justify-content-center">
                                        <div 
                                            style={{
                                                border: "2px dashed orange",
                                                backgroundColor: "#FFF3CD",
                                                padding: "20px",
                                                textAlign: "center",
                                                width: "50%",
                                                borderRadius: "8px",
                                                cursor: "pointer"
                                            }}
                                            onClick={() => document.getElementById("fileUpload").click()}
                                        >
                                            <input
                                                type="file"
                                                id="fileUpload"
                                                style={{ display: "none" }}
                                                onChange={this.handleFileUpload}
                                                accept="image/*"
                                            />
                                             <img
                                                src={uploadIcon}
                                                alt="upload"
                                                style={{ width: '25px',  }} // Adjust size as needed
                                            />
                                            <p style={{ margin: "10px 0", color: "#000" }}>Upload Item Image</p>
                                        </div>
                                    </Col>
                                </Row>
                            </AccordionItemPanel>
                        </AccordionItem>

                        {/* Section 2 */}
                        <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                    <span className="accordian_title">Product Attributes</span>
                                    
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="email">Ean</Label>
                                            <Input
                                                type="text"
                                                name="ean"
                                                id="email"
                                                onChange={this.handleChange}
                                                defaultValue={this.state.ean}
                                                
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">UPC</Label>
                                            <Input
                                                type="text"
                                                name="upc"
                                                id="email"
                                                onChange={this.handleChange}
                                                defaultValue={this.state.upc}
                                                
                                            />
                                            {/* <select
                                                name="upc"
                                                className="form-control"
                                                value={this.state.upc}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                            >
                                                <option value="">Select Type</option>
                                                <option value={dropDownData.item_type}>{dropDownData.item_type}</option>

                                                {this.state.taxType.map((item) => (
                                                    <option key={item.value} value={item.value}>{item.label}</option>
                                                ))}
                                            </select>*/}
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row form>
                                    <span style={{fontSize: 15, fontWeight: 'bold', color: 'black', width: '100%', marginBottom: 4}}> EAN Each</span>
                                    <Col md={4}>
                                        
                                        <FormGroup>
                                            <Label for="mobile">Length</Label>
                                            <Input
                                                type="number"
                                                name="ean_each_length"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                defaultValue={this.state.ean_each_length}
                                                

                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Breadth</Label>
                                            <Input
                                                type="number"
                                                name="ean_each_breadth"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                defaultValue={this.state.ean_each_breadth}
                                                
                                            />
                                        </FormGroup>
                                    </Col>
                                     <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Height</Label>
                                            <Input
                                                type="number"
                                                name="ean_each_height"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                defaultValue={this.state.ean_each_height}
                                                
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>

                                

                                 <Row form>
                                    <span style={{fontSize: 15, fontWeight: 'bold', color: 'black', width: '100%', marginBottom: 4}}> EAN Cases</span>
                                    <Col md={4}>
                                        
                                        <FormGroup>
                                            <Label for="mobile">Length</Label>
                                            <Input
                                                type="text"
                                                name="ean_cases_length"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                defaultValue={this.state.ean_cases_length}
                                                
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Breadth</Label>
                                            <Input
                                                type="text"
                                                name="ean_cases_breadth"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                defaultValue={this.state.ean_cases_breadth}
                                                
                                            />
                                        </FormGroup>
                                    </Col>
                                     <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Height</Label>
                                            <Input
                                                type="text"
                                                name="ean_cases_height"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                defaultValue={this.state.ean_cases_height}
                                                
                                                
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                 <Row form>
                                    
                                    <Col md={4}>
                                        
                                        <FormGroup>
                                            <Label for="mobile">Shelf Life (Months)</Label>
                                            <Input
                                                type="number"
                                                name="shelf_life"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                defaultValue={this.state.shelf_life}                                                
                                                

                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">MRSL (Percentage)</Label>
                                            <Input
                                                type="number"
                                                name="mrsl"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                defaultValue={this.state.mrsl}
                                                
                                            />
                                        </FormGroup>
                                    </Col>
                            
                                </Row>
                            </AccordionItemPanel>
                        </AccordionItem>
                         <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                    <span className="accordian_title">Pricing Details</span> 
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="email">MRP</Label>
                                            <Input
                                                type="number"
                                                name="mrp"
                                                id="email"
                                                onChange={this.handleChange}
                                                value={this.state.mrp}
                                                disabled
                                                
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Std Cost</Label>
                                            <Input
                                                type="number"
                                                name="std_cost"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                defaultValue={this.state.std_cost}
                                                
                                            />
                                        </FormGroup>
                                    </Col>
                                
                                
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Per Qty.</Label>
                                            <Input
                                                type="number"
                                                name="per_qty"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                defaultValue={this.state.per_qty}
                                                
                                            />
                                        </FormGroup>
                                    </Col>
                                   
                                </Row>
                            </AccordionItemPanel>
                        </AccordionItem>

                         <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                    <span className="accordian_title">UOM Details</span>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="email">Purchase UOM</Label>
                                            <Input
                                                type="text"
                                                name="purchase_uom"
                                                id="email"
                                                onChange={this.handleChange}
                                                defaultValue={this.state.purchase_uom}
                                                
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Std Purchase Price</Label>
                                            <Input
                                                type="text"
                                                name="std_purchase_price"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                defaultValue={this.state.std_purchase_price}
                                                
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Sales UOM</Label>
                                            <Input
                                                type="text"
                                                name="sales_uom"
                                                id="mobile"
                                                onChange={this.handleChange}
                                                defaultValue={this.state.sales_uom}
                                                
                                            />
                                        </FormGroup>
                                    </Col>
                                    {/*<Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Std Purchase Price</Label>
                                            <Input
                                                type="text"
                                                name="std_purchase_price"
                                                id="mobile"
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>*/}
                                </Row>
                            </AccordionItemPanel>
                        </AccordionItem>
                    </Accordion>

                    {this.state.isAccordionOpen && (
                        <div style={{
                           
                            bottom: 0,
                            left: 0,
                            width: '100%',
                            backgroundColor: 'white',
                            boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.1)',
                            padding: '15px 0',
                            textAlign: 'center'
                        }}>
                            <button 
                                onClick={this.toggleBack} 
                                style={{
                                    backgroundColor: 'white',
                                    border: '2px solid #FBBB00',
                                    color: 'black',
                                    padding: '8px 22px',
                                    fontSize: '16px',
                                    marginRight: '10px',
                                    borderRadius: '5px',
                                    cursor: 'pointer'
                                }}
                            >
                                Cancel
                            </button>

                            <button 
                                onClick={this.updateItem} 
                                id="createUserBtn" 
                                style={{
                                    backgroundColor: '#FBBB00',
                                    border: 'none',
                                    color: 'black',
                                    padding: '8px 22px',
                                    fontSize: '16px',
                                    borderRadius: '5px',
                                    cursor: 'pointer'
                                }}
                            >
                                Update
                            </button>
                        </div>
                    )}

                   

                <Modal isOpen={modalNew} backdrop="static" toggle={this.toggleNew}>
                  <div className="modal__header">
                    <button
                      className="lnr lnr-cross modal__close-btn"
                      type="button"
                      style={{ right: 15 }}
                      onClick={this.toggleNew}
                    />
                  </div>
                  <div
                    className="modal__body"
                    style={{ paddingTop: 55, paddingBottom: 20 }}
                  >
                    <span
                      className="lnr lnr-thumbs-up modal__title-icon"
                      style={{ color: "#4ce1b6" }}
                    />
                    <h4>{this.state.success_message} </h4>
                    
                  </div>
                  <ButtonToolbar className="modal__footer">
                    <Button
                      style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                      className="modal_ok"
                      onClick={this.toggleNew}
                    >
                      Ok
                    </Button>
                  </ButtonToolbar>
                </Modal>

                <Modal isOpen={failedModal} backdrop="static" toggle={this.Failedtoggle}>
                    <div className="modal__header">
                      <button
                        className="lnr lnr-cross modal__close-btn"
                        type="button"
                        style={{ right: 15 }}
                        onClick={this.Failedtoggle}
                      />
                    </div>
                    <div
                      className="modal__body"
                      style={{ paddingTop: 55, paddingBottom: 20 }}
                    >
                      <span
                        className="lnr lnr-cross-circle modal__title-icon"
                        style={{ color: "red" }}
                      />
                      <h4>{this.state.failed_message} </h4>
                    </div>
                    <ButtonToolbar className="modal__footer">
                      <Button
                        style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                        className="modal_ok"
                        onClick={this.Failedtoggle}
                      >
                        Ok
                      </Button>
                    </ButtonToolbar>
                </Modal>



              
            </div>
        );
    }
}

export default HorizontalForm;
